import React, { useEffect, useRef, useState } from "react";
import Button from "../../../forms/Button";
import Input from "../../../form/Input";
import Image from "../../../elements/Image";
import UserImage from "../../../../assets/images/image-user-06.webp";
import { useSelector } from "react-redux";
import useForm from "../../../../hooks/useForm";
import { formValidate } from "../../../../helpers/formValidate";
import { initialsValue } from "../../../../helpers";
import Indentification from "../../../elements/Indentification";
import useMutation from "../../../../hooks/useMutation";
import { editauth0user } from "../../../../services/userService";
import ButtonFile from "../../../form/ButtonFile";
import { useDispatch } from "react-redux";
import Textarea from "../../../form/Textarea";

const ProfileView = () => {
  const [isProfileEditable, setProfileEditable] = useState(false);
  const user = useSelector((state) => state?.profile?.data);
  const validation = {
    firstName: { required: true, message: "Please enter your first name!" },
    lastName: { required: true, message: "Please enter your last name!" },
    email: { required: true, message: "Please enter your email!" },
    // phone: { required: true, message: "Please enter your phone!" },
  };

  const dispatch = useDispatch();
  const { values, handleChange, handleSubmit, errors, setFieldsValue } = useForm({
    validationRules: validation,
  });
  // console.log(user, "use");
  useEffect(() => {
    if (user) {
      const { phone, image } = user;

      setFieldsValue({
        firstName: user?.firstName || "",
        lastName: user?.lastName || "",
        email: user?.email || "",
        image: image?.url || image || null,
        phone: {
          countryCode: phone?.countryCode || "",
          number: phone?.number || "",
          fullNumber: phone?.fullNumber || "",
        },
      });
    }
  }, [user]);

  const {
    mutate,
    isPending: isSaving,
    error,
  } = useMutation({
    mutationFn: async (payload) => {
      const formData = new FormData();

      if (selectedFile) {
        formData.append("image", selectedFile);
      }

      formData.append("firstName", payload.firstName);
      formData.append("lastName", payload.lastName);
      formData.append("email", payload.email);

      // Append phone fields with bracket notation
      formData.append("phone[countryCode]", payload?.phone?.countryCode || "");
      formData.append("phone[number]", payload?.phone?.number || "");
      formData.append("phone[fullNumber]", payload?.phone?.fullNumber || "");

      return await editauth0user(formData);
    },

    onSuccess: (res) => {
      setProfileEditable(false);
      setSelectedFile(null);
      // dispatch(getProfile());
      window.location.reload();
    },
  });

  const inputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setFieldsValue({ image: file });
    }
  };

  const triggerFileSelect = () => {
    inputRef.current?.click();
  };

  const imageUrl = selectedFile ? URL.createObjectURL(selectedFile) : UserImage;

  return (
    <>
      <div className="relative">
        <div className="mb-4 pb-4 border-b border-md-pink-light-1 pr-6 space-y-2">
          <div className="w-full space-y-1">
            <div className="text-lg 2xl:text-xl text-md-dark font-semibold">Profile Informations</div>
            <div className="text-sm text-slate-500 tracking-wide">Manage and update your personal details such as your name, email address, phone number, and profile photo. Keeping this information accurate helps ensure better communication and a more personalized experience across the platform.</div>
          </div>
          <div className="ml-auto flex-shrink-0 flex items-center gap-1">
            {isProfileEditable ? (
              <>
                <Button
                  buttonHasLink={false}
                  buttonIcon={"fa-regular fa-fw fa-xmark"}
                  buttonIconPosition={"left"}
                  buttonLabel={"Cancel"}
                  buttonClasses={"!h-auto !rounded !px-2 !py-1 !text-md-pink !bg-transparent hover:!bg-md-pink/10 !gap-1"}
                  buttonLabelClasses={"!font-semibold !text-md-dark !text-sm"}
                  buttonFunction={() => setProfileEditable(false)}
                />
                <Button
                  buttonHasLink={false}
                  buttonIcon={"fa-regular fa-fw fa-floppy-disk"}
                  buttonIconPosition={"left"}
                  buttonLabel={isSaving ? "Saving..." : "Save"}
                  buttonClasses={"!h-auto !rounded !px-2 !py-1 !text-md-pink !bg-transparent hover:!bg-md-pink/10 !gap-1"}
                  buttonLabelClasses={"!font-semibold !text-md-dark !text-sm"}
                  // buttonFunction={() => setProfileEditable(false)}
                  buttonFunction={(e) => handleSubmit(e, (formValues) => mutate(formValues))}
                  isDisabled={isSaving}
                />
              </>
            ) : (
              <Button
                buttonHasLink={false}
                buttonIcon={"fa-regular fa-fw fa-pen-to-square"}
                buttonIconPosition={"left"}
                buttonLabel={"Edit Profile"}
                buttonClasses={"!h-auto !rounded !px-2 !py-1 !text-md-pink !bg-transparent hover:!bg-md-pink/10 !gap-1"}
                buttonLabelClasses={"!font-semibold !text-md-dark !text-sm"}
                buttonFunction={() => setProfileEditable(true)}
              />
            )}
          </div>
        </div>
        <div className="relative space-y-6">
          <div className="relative">
            <div className="text-sm 2xl:text-base font-medium text-slate-500 mb-1">Profile Image</div>
            <div className="w-28 aspect-square overflow-hidden rounded-lg flex flex-shrink-0">
               
                <Indentification
                  initial={initialsValue(`${user?.firstName} ${user?.lastName}`)}
                  image={values.image instanceof File ? URL.createObjectURL(values.image) : values?.image || user?.image?.url || user?.image}
                  size="max"
                  alt={""}
                  defaultClass={"text-base"}
                  className={"!border-none flex-shrink-0 !rounded-lg"}
                  fill={true}
                  initialClass={"!text-4xl !rounded-lg"}
                />
              </div>
              {isProfileEditable && (
                <div className="flex-shrink flex-grow space-y-1 flex flex-col justify-start items-start">
                  <div className="relative">
                    <input type="file" accept="image/*" ref={inputRef} onChange={handleFileChange} hidden style={{ display: "none" }} />
                    {/* <Button
                    buttonHasLink={false}
                    buttonLabel={"Change avatar"}
                    buttonClasses={"!rounded-md !h-10 !px-3"}
                    buttonLabelClasses={"!font-medium"}
                    buttonFunction={triggerFileSelect}
                  /> */}
                    <ButtonFile buttonIcon="fa-regular fa-fw fa-camera" buttonLabel="Change avatar" buttonIconPosition="left" buttonLabelClasses="!font-medium" buttonClasses="!rounded-md !h-10 !px-3" onChange={handleFileChange} />
                    <div className="text-xs text-slate-500 tracking-wide font-medium">JPG, GIF or PNG. 2MB max.</div>
                  </div>
                </div>
              )}
          </div>
          {isProfileEditable ? (
            <div className="grid sm:flex gap-4">
              <Input label="First Name" labelClasses={"text-sm 2xl:text-base"} inputType="text" value={values.firstName} inputPlaceholder="Enter first name" inputName="firstName" isValidate={true} onChange={handleChange} required {...formValidate(errors, "firstName")} />
              <Input label="Last Name" labelClasses={"text-sm 2xl:text-base"} inputType="text" value={values.lastName} inputPlaceholder="Enter last name" inputName="lastName" isValidate={true} onChange={handleChange} required {...formValidate(errors, "lastName")} />
            </div>
          ) : (
            <div className="relative">
              <div className="text-sm 2xl:text-base font-medium text-slate-500">Full Name</div>
              <div className="text-lg 2xl:text-xl font-semibold text-md-dark flex items-center">
                {user?.firstName ?? "First name"} {user?.lastName ?? "Last name"}
              </div>
            </div>
          )}
          <div className="grid grid-cols-1 gap-4">
            {isProfileEditable ? (
              <div className="relative">
                <Input label="Email" labelClasses={"text-sm 2xl:text-base"} inputType="text" value={values.email} inputPlaceholder="Enter email" inputName="email" isValidate={true} onChange={handleChange} isDisabled required {...formValidate(errors, "email")} />
              </div>
            ) : (
              <div className="relative">
                <div className="text-sm 2xl:text-base font-medium text-slate-500">Email Address</div>
                <div className="text-lg 2xl:text-xl font-semibold text-md-dark flex items-center">{user?.email ?? "Add email address"}</div>
              </div>
            )}
            {isProfileEditable ? (
              <div className="grid sm:flex items-center gap-1 md:gap-2">
                <div className="flex-shrink-0 sm:w-24">
                  <Input
                    label="Country Code"
                    inputPlaceholder="e.g:- +91"
                    inputName="phone.countryCode"
                    value={values?.phone?.countryCode || ""}
                    onChange={(e) => {
                      const countryCode = e.target.value.trim();
                      const number = values?.phone?.number || "";
                      const fullNumber = `${countryCode}${number}`;
                      handleChange({
                        target: {
                          name: "phone",
                          value: {
                            ...values?.phone,
                            countryCode,
                            fullNumber,
                          },
                        },
                      });
                    }}
                  />
                </div>

                <div className="flex-shrink flex-grow">
                  <Input
                    label="Phone Number"
                    labelClasses="text-sm 2xl:text-base"
                    inputType="text"
                    inputName="phone.number"
                    inputPlaceholder="Enter phone number"
                    value={values?.phone?.number || ""}
                    onChange={(e) => {
                      const number = e.target.value.trim();
                      const countryCode = values?.phone?.countryCode || "";
                      const fullNumber = `${countryCode}${number}`;
                      handleChange({
                        target: {
                          name: "phone",
                          value: {
                            ...values?.phone,
                            number,
                            fullNumber,
                          },
                        },
                      });
                    }}
                    {...formValidate(errors, "phone")}
                  />
                </div>
              </div>
            ) : (
              <div className="relative">
                <div className="text-sm 2xl:text-base font-medium text-slate-500">Phone number</div>
                <div className="text-lg 2xl:text-xl font-semibold text-md-dark flex items-center">{`${user?.phone?.countryCode || ""} ${user?.phone?.number || ""}`.trim() || "Add phone number"}</div>
              </div>
            )}

            {isProfileEditable ? (
              <div className="relative sm:col-span-2">
                <div className="relative">
                  <Textarea label="Address" labelClasses={"text-sm 2xl:text-base"} inputPlaceholder="Your address" />
                </div>
              </div>
            ) : (
              <div className="relative">
                <div className="text-sm 2xl:text-base font-medium text-slate-500">Address</div>
                <div
                  className="text-lg 2xl:text-xl font-semibold text-md-dark flex items-center"
                  dangerouslySetInnerHTML={{
                    __html: "1234 Elm Street\n Apt 56B Springfield,\n IL 62704, United States ".replace(/\n/g, "<br />"),
                  }}
                />
              </div>
            )}
          </div>
        </div>
        {isProfileEditable && (
          <div className="mt-4 pt-4 border-t border-md-pink-light-1 flex items-start justify-between gap-4">
            <div className="ml-auto flex-shrink-0 flex items-center gap-1 md:gap-2">
              <Button
                buttonHasLink={false}
                buttonIcon={"fa-regular fa-fw fa-xmark"}
                buttonIconPosition={"left"}
                buttonLabel={"Cancel"}
                buttonClasses={"!h-10 !rounded-md !px-3 !bg-md-pink-light-2 border border-md-pink-light-1 !text-md-pink hover:!bg-md-pink-light-1 hover:border-md-pink/20"}
                buttonLabelClasses={"!font-medium !pb-1 !leading-none"}
                buttonFunction={() => setProfileEditable(false)}
              />
              <Button
                buttonHasLink={false}
                buttonIcon={"fa-regular fa-fw fa-floppy-disk"}
                buttonIconPosition={"left"}
                buttonLabel={isSaving ? "Saving..." : "Save"}
                buttonClasses={"!h-10 !rounded-md !px-3"}
                buttonLabelClasses={"!font-medium !pb-1 !leading-none"}
                isDisabled={isSaving}
                buttonFunction={(e) => handleSubmit(e, (formValues) => mutate(formValues))}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProfileView;
